<template>
    <div class="card-container">
        <common-table :data="tableData" ref="commonTable" :isShow="false">
            <el-table-column prop="id" label="鼓励金编号" min-width="180" :formatter="formatterTableData" show-overflow-tooltip></el-table-column>
            <el-table-column prop="name" label="鼓励金名称" min-width="180" :formatter="formatterTableData" show-overflow-tooltip></el-table-column>
            <el-table-column prop="money" label="面值(元)" min-width="180" :formatter="formatterTableData"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="profit" label="总分润(元)" min-width="120" :formatter="formatterTableData"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="oneProfit" label="所属代理商第一次(元)" min-width="200" :formatter="formatterTableData"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="towProfit" label="所属代理商第二次(元)" min-width="200" :formatter="formatterTableData"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="threeProfit" label="所属代理商第三及以上(元)" min-width="200" :formatter="formatterTableData"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="parentProfit" label="直接推上级(元)" min-width="180" :formatter="formatterTableData"
                             show-overflow-tooltip></el-table-column>
            <el-table-column v-if="hasPerm('/leyingoldconfiguration/update')" label="操作" min-width="100"
                             fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" @click="openAddDialog(scope.row)">修改</el-button>
                </template>
            </el-table-column>
        </common-table>
        <form-dialog ref="formDialog" formDialogTitle="修改" :model="dialogModel"
                     :submitData="dialogData" :rules="dialogRules" :dialogService="dialogService" @close="dialogClose"
                     @success="dialogSuccess" class="note leyinonly" labelWidth="190px" dialogWidth="460px">
            <div class="flex-row vertical-center flow-justify" style="margin-bottom: 20px;">
                <div>鼓励金编号： {{dialogModel.id}}</div>
                <div>鼓励金名称： {{dialogModel.name}}</div>
            </div>
            <el-form-item  label-width="190px" label="面值(元)" prop="money">
                <el-input-number
                    v-model="dialogModel.money"
                    :min="0"
                    :max="999999999"
                    :step="0.1"
                    :precision="2"
                    :controls="false"
                    placeholder="请输入"
                ></el-input-number>
            </el-form-item>
            <el-form-item label-width="190px" label="总分润(元)" prop="profit">
                <el-input-number
                    v-model="dialogModel.profit"
                    :min="0"
                    :max="999999999"
                    :step="0.1"
                    :precision="2"
                    :controls="false"
                    placeholder="请输入"
                ></el-input-number>
            </el-form-item>
            <el-form-item label-width="190px" label="所属代理商第一次(元)" prop="oneProfit">
                <el-input-number
                    v-model="dialogModel.oneProfit"
                    :min="0"
                    :max="999999999"
                    :step="0.1"
                    :precision="2"
                    :controls="false"
                    placeholder="请输入"
                    class="flex-1"
                ></el-input-number>
            </el-form-item>
            <el-form-item label-width="190px" label="所属代理商第二次(元)" prop="towProfit">
                <el-input-number
                    v-model="dialogModel.towProfit"
                    :min="0"
                    :max="999999999"
                    :step="0.1"
                    :precision="2"
                    :controls="false"
                    placeholder="请输入"
                ></el-input-number>
            </el-form-item>
            <el-form-item label-width="190px" label="所属代理商第三及以上(元)" prop="threeProfit">
                <el-input-number
                    v-model="dialogModel.threeProfit"
                    :min="0"
                    :max="999999999"
                    :step="0.1"
                    :precision="2"
                    :controls="false"
                    placeholder="请输入"
                ></el-input-number>
            </el-form-item>
            <el-form-item label-width="190px" label="直接推上级(元)" prop="parentProfit">
                <el-input-number
                    v-model="dialogModel.parentProfit"
                    :min="0"
                    :max="999999999"
                    :step="0.1"
                    :precision="2"
                    :controls="false"
                    placeholder="请输入"
                ></el-input-number>
            </el-form-item>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import FormDialog from "../../dialog/FormDialog";

    import TransactionService from "service/TransactionService";

    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from "vuex";

    export default {
        name: "twoapppointsnewodetojoymanage",
        components: {
            CommonTopForm,
            CommonTable,
            FormDialog,
        },
        data() {
            return {
                show: false,
                tableData: [],
                submitService: TransactionService.zxgljprofitlist,
                itemId: "",
                dialogModel: {
                    id: "",
                    money: 0,
                    profit: 0,
                    oneProfit: 0,
                    towProfit: 0,
                    threeProfit: 0,
                    parentProfit: 0,
                },
                dialogRules: {
                    money: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    profit: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    oneProfit: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    towProfit: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    threeProfit: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    parentProfit: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                },
                isFlag: false,
                currentTypes: {},
            };
        },
        inject: ["reload"],
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.load();
        },
        computed: {
            dialogData() {
                const params = {
                    id: this.dialogModel.id,
                    money: this.dialogModel.money,
                    oneProfit: this.dialogModel.oneProfit,
                    parentProfit: this.dialogModel.parentProfit,
                    profit: this.dialogModel.profit,
                    threeProfit: this.dialogModel.threeProfit,
                    towProfit: this.dialogModel.towProfit,
                };
                return params;
            },
            dialogService() {
                return TransactionService.zxgljprofitedit;
            },
            ...mapGetters(["serverType", "tatId", "userId"]),
        },
        watch: {},
        methods: {
            load() {
                this.getList();
            },
            getList() {
                this.doLoad(
                    this.submitService,
                    {},
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.onSuccess(res);
                        });
                    },
                    "信息获取失败"
                );
            },
            openAddDialog(item, flag) {
                this.dialogModel = item;
                // for(let i in this.dialogModel){
                //     if (i != 'id' && i !='name') {
                //         this.dialogModel[i] = this.toYuan(this.dialogModel[i])
                //     }
                // }
                this.$refs.formDialog.open();
            },

            dialogClose() {
                this.dialogModel = {
                    id: "",
                    money: 0,
                    profit: 0,
                    oneProfit: 0,
                    towProfit: 0,
                    threeProfit: 0,
                    parentProfit: 0,
                };
            },
            dialogSuccess(res) {
                this.commonSuccess(res);
                this.$refs.formDialog.closeDialog();
            },
            commonSuccess(res) {
                this.showSuccess(res.respMsg);
                this.getList();
            },
            onSuccess(res) {
                this.doCheck(res, (res) => {
                    const result = res.contents;
                    this.tableData = result;
                });
            },
        },
    };
</script>

<style scoped>
    .button {
        width: 50px;
        padding: 11px 10px;
        margin-left: 49px;
        display: block;
        float: left;
    }

    .text {
        width: 145px !important;
        margin-left: 12px;
        float: left;
    }

    .mem-name p {
        margin-bottom: 20px;
        vertical-align: middle;
        line-height: 40px;
        color: rgba(170, 170, 170, 1);
    }

    .mem-name p:first-child {
        display: inline-block;
        width: 90px;
        text-align: right;
        vertical-align: middle;
        font-size: 14px;
        color: #606266;
        line-height: 40px;
    }

    .chenk {
        width: 60px;
        position: relative;
        top: -61px;
        left: 189px;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar {
        width: 100px;
        height: 100px;
        display: block;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
    }

    .iconUrl {
        width: 50px;
        height: 50px;
        margin: auto;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/LeyinGoldConfiguration.vue